import { useEffect } from 'react';

import { getOneClickConsoleOrigin, isOneClick } from '@cast/constants';
import { useAbility } from '@cast/shared-ability-data-access';

import { RedesignAnnouncementBanner } from '../_hooks/useRedesignAnnouncement/_components/RedesignAnnouncementBanner';
import { useRedesignAnnouncementDialog } from '../_hooks/useRedesignAnnouncement/_components/RedesignAnnouncementDialog';
import { setRedesignAnnouncementDialogOpen } from '../_hooks/useRedesignAnnouncement/redesignAnnouncementDialogGate';
import { useRedesignAnnouncementState } from 'main-layout-op/_hooks/useRedesignAnnouncement/useRedesignAnnouncementState';

export const ConsoleRedesignAnnouncement = () => {
  const canView = useAbility().can('view', 'FeatureOneClickPromotion');
  const oneClickUrl = getOneClickConsoleOrigin();
  const { bannerDismissed, dismissBanner, dialogSeen, markDialogSeen } =
    useRedesignAnnouncementState();
  const { openDialog } = useRedesignAnnouncementDialog();

  const enabled = canView && !isOneClick();

  // Clear stale in-memory gate after HMR when the dialog will not open again.
  useEffect(() => {
    if (dialogSeen) {
      setRedesignAnnouncementDialogOpen(false);
    }
    // Intentionally mount-only — do not clear the gate when markDialogSeen()
    // runs while the dialog is still open.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!enabled || dialogSeen) {
      return;
    }
    setRedesignAnnouncementDialogOpen(true);
    openDialog(
      { oneClickUrl },
      {
        onClose: () => {
          setRedesignAnnouncementDialogOpen(false);
        },
      }
    );
    markDialogSeen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, dialogSeen, markDialogSeen, oneClickUrl]);

  if (!enabled || bannerDismissed) {
    return null;
  }

  return (
    <RedesignAnnouncementBanner
      oneClickUrl={oneClickUrl}
      onClose={() => {
        dismissBanner();
        markDialogSeen();
      }}
    />
  );
};
